<template>
    <v-card width="100%">
        <v-card-title>
            <span>Список загрузок</span>
        </v-card-title>
        <v-card-text>
            <v-data-table loading v-show="loading" loading-text="Пожалуйста подождите... Загрузка"/>

            <v-data-table v-show="!loading" :sort-desc.sync="sortDesc" :search="search" :sort-by.sync="sortBy"
                          @update:options="changeSort"
                          :headers="headers"
                          show-select :items="filteredItems" v-model="selected">
                <template v-slot:top>
                    <v-row class="align-center">
                        <v-col cols="12">
                            <v-row>
                                <v-checkbox label="Показать активные" v-model="active" @change="getTorrents"/>
                                <!--                            <v-select :items="status" item-value="id" item-text="name" clearable-->
                                <!--                                      label="Статус загрузки" v-model="state"/>-->
                                <v-spacer/>
                                <v-text-field clearable
                                              v-model="search"
                                              append-icon="mdi-magnify"
                                              label="Фильтр"
                                              single-line
                                              hide-details/>
                            </v-row>
                            <v-btn color="#cc7b19" small class="text-none" depressed @click="selectFile">
                                <v-icon left>mdi-cloud-upload</v-icon>
                                Добавить
                                <input class="d-none" type="file" multiple ref="select" @change="choiceTarget">
                            </v-btn>

                            <v-btn :disabled="!selected.length" color="#cc7b19" small class="text-none" depressed
                                   @click="pauseTorrents">
                                <v-icon>mdi-pause</v-icon>
                            </v-btn>
                            <v-btn :disabled="!selected.length" color="#cc7b19" small class="text-none" depressed
                                   @click="startTorrents">
                                <v-icon>mdi-play</v-icon>
                            </v-btn>
                            <v-btn :disabled="!selected.length" color="red" small class="text-none" depressed
                                   @click="deleteTorrents">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.name="{item}">
                    <v-tooltip color="black" left open-on-focus>
                        <template v-slot:activator="{on}">
                            <span v-on="on">{{ item.name.substr(0, 25) }}...</span>
                        </template>
                        <span>{{ item.name }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.status="{item}">
                    {{ status.find(x => x.id === item.status).name }}
                </template>
                <template v-slot:item.recDone="{item}">
                    <v-progress-linear v-if="!isMobile()" color="#cc7b19" height="18" v-model="item.recDone">
                        <template v-slot="{ value }">
                            <span>{{ Math.round(value) }}%</span>
                        </template>
                    </v-progress-linear>
                    <span v-else>{{ Math.round(item.recDone) }}%</span>

                </template>
                <template v-slot:item.eta="{item}">
                    <span v-if="item.status === 4">{{ item.eta }}</span>
                    <span v-else>Скачан</span>
                </template>
                <template v-slot:item.rate="{item}">
                    <v-icon color="green" small>mdi-arrow-down</v-icon>
                    {{ item.rateDown }} /
                    <v-icon color="#cc7b19" small>mdi-arrow-up</v-icon>
                    {{ item.rateUp }}
                </template>
                <template v-slot:item.uploadRatio="{item}">
                  <span> {{ item.uploadRatio.toFixed(1) }}</span>
                </template>
                <template v-slot:item.priorities="{item}">
                    <v-icon color="green" @click="changePriorities(item.id, 'up')">mdi-chevron-double-up</v-icon>
                    <span
                        v-bind:style="{color: prioritiesValue.find(x => x.value === item.priorities).color}">{{
                            prioritiesValue.find(x => x.value === item.priorities).text
                        }}</span>
                    <v-icon color="red" @click="changePriorities(item.id, 'down')">mdi-chevron-double-down</v-icon>
                </template>
            </v-data-table>
        </v-card-text>
        <choice-add-torrent ref="choiceAddTorrent" v-on:addTorrent="uploadFile"/>
        <v-btn v-scroll="onScroll" class="mb-8 up-button" v-show="fab" fab dark fixed bottom left @click="toTop">
            <v-icon>mdi-arrow-up-bold-circle</v-icon>
        </v-btn>
    </v-card>
</template>

<script>
import choiceAddTorrent from "@/components/choiceAddTorrent";

export default {
    name: 'torrents',
    components: {choiceAddTorrent},
    data() {
        return {
            sortBy: 'recDone',
            sortDesc: false,
            wait: false,
            fab: false,
            active: false,
            files: [],
            loading: true,
            selected: [],
            search: '',
            freeSpace: 0,
            state: 50,
            prioritiesValue: [
                {text: 'низкий', color: 'red', value: -1},
                {text: 'средний', color: 'white', value: 0},
                {text: 'высокий', color: 'green', value: 1}
            ],
            headers: [
                {text: 'статус', value: 'status', align: 'center'},
                {text: '% загрузки', value: 'recDone', align: 'center'},
                {text: 'приоритет', value: 'priorities', align: 'center', sortable: false,},
                {text: 'скорость', value: 'rate', align: 'center', sortable: false,},
                {text: 'осталось', value: 'eta', align: 'center',},
                {text: 'ratio', value: 'uploadRatio', align: 'center',},
                {text: 'размер', value: 'size', align: 'center',},
                {text: 'название', value: 'name'},

            ],
            torrents: [],
            status: [
                {'id': 0, 'name': 'Пауза'},
                {'id': 1, 'name': 'В очереди на проверку'},
                {'id': 2, 'name': 'Проверка'},
                {'id': 3, 'name': 'В очереди'},
                {'id': 4, 'name': 'Загрузка'},
                {'id': 5, 'name': 'В очереди на раздачу'},
                {'id': 6, 'name': 'Раздача'},
                {'id': 7, 'name': 'Нет пиров'}
            ]
        }
    },
    computed: {
        filteredItems() {
            if (this.state === 50 || this.state === undefined) {
                return this.torrents
            }
            return this.torrents.filter((i) => {
                return (i.status === this.state);
            })
        }
    },
    created() {
        this.getTorrents()
        this.interval = setInterval(() => this.getTorrents(), 3000);
        this.$store.dispatch('updateToken')
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        changeSort({sortBy}) {
            this.sortBy = sortBy[0]
        },
        onScroll(e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset || e.target.scrollTop || 0
            this.fab = top > 20
        },
        toTop() {
            this.$vuetify.goTo(0)
        },
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        /**
         *
         * @param id
         * @param action
         */
        changePriorities(id, action) {
            this.$http.post('/changePriorities/' + id, {action: action})
        },
        /**
         *
         * @returns {Promise<void>}
         */
        async deleteTorrents() {
            confirm('Подтвердите удаление загрузок. Внимание!!! Будут удаленны так же данные!!!')
            && await this.$http({
                method: 'post',
                url: '/deleteTorrents',
                data: this.selected
            }).then(() => {
                this.getTorrents()
            })
        },
        selectFile() {
            this.$refs.select.click()
        },
        pauseTorrents() {
            this.$http.post('/pauseTorrents', this.selected).then(() => {
                this.selected = []
                this.getTorrents()
            })
        },
        startTorrents() {
            this.$http.post('/startTorrents', this.selected).then(() => {
                this.selected = []
                this.getTorrents()
            })
        },
        choiceTarget(e) {
            this.files = e.target.files
            for (let file of e.target.files) {
                if (file.name.indexOf('.torrent') === -1) {
                    alert('Не правильный формат файла! ' + file.name)
                    return
                }
            }
            this.$refs.choiceAddTorrent.open()
        },
        /**
         *
         * @param path
         */
        uploadFile(path) {
            let formData = new FormData()
            for (let i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('path', path.catalog)
            this.$http.post('/addTorrents', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((resp) => {
                if (resp.data.status === 200) {
                    this.getTorrents()
                }
                this.files = []
            })

        },
        /**
         *
         */
        getTorrents() {
            if (!this.wait) {
                let url = ''
                if (this.active === true) {
                    url = '/getActiveTorrent'
                } else {
                    url = '/getAllTorrents'
                }
                this.wait = true
                this.$http.get(url).then((resp) => {
                    this.torrents = resp.data
                    this.wait = false
                }).catch((err) => {
                    console.log(err)
                    this.wait = false
                })
            }
            this.loading = false
        },
    }
}
</script>

<style scoped>
.v-btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
    margin-top: 5px !important;
}

.filterSelect {
    max-width: 200px;
}

.up-button {
    z-index: 999999999 !important;
}
</style>
